import { type Writable, writable } from "svelte/store";

export class TrackingStore {
  sendTrackingLabelOnFocus: Writable<boolean> = writable(true);
}

export const trackingStore = new TrackingStore();
export const sendTrackingLabelOnFocus = trackingStore.sendTrackingLabelOnFocus;
